import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

// internals.addVehicles = function(vehicle) {
//     vehicle = (({
    //   vNumber,
    //   vMakeYear,
    //   vModelName,
    //   vType,
    //   assignGpsId,
    // _id,
//   }) => {
//     return {
//       vNumber,
//       vMakeYear,
//       vModelName,
//       vType,
//       assignGpsId,
//     _id,
//     };
//   })(vehicle);

//   return vm.$vehicleDataRepository
//     .create(vehicle)
//     .then(result => {
//         vehicle = result.data;
//       return vehicle;
//     })
//     .catch(error => {
//       console.error('VehicleService.createVehicle-error:\n', error);
//       throw error;
//     });
// };

// internals.updateVehicles = function(vehicle) {
//     vehicle = Object.assign({}, vehicle);
//     vehicle = (({
//       vNumber,
//       vMakeYear,
//       vModelName,
//       vType,
//       assignGpsId,
//       status,
//     _id,
//   }) => {
//     return {
//       vNumber,
//       vMakeYear,
//       vModelName,
//       vType,
//       assignGpsId,
//       status,
//     _id,
//     };
//   })(vehicle);
//     return vm.$vehicleDataRepository
//     .update(vehicle._id, vehicle)
//     .then(result => {
//         vehicle = result.data;
//       return vehicle;
//     })
//     .catch(error => {
//       console.error('VehicleUpdate.update-error:\n', error);
//       throw error;
//     });
// };
internals.addVehicles = (vehicle) => {
  vehicle = Object.assign({}, vehicle)
 
  const promises = [];
  return http
    .post("/vehicle/create", {
      cityId: vehicle.cityId,
      vNumber: vehicle.vNumber,
      vMakeYear: vehicle.vMakeYear,
      vModelName: vehicle.vModelName,
      // vType: vehicle.vType,
      assignGpsId: vehicle.assignGpsId,
    })
    .then((result) => {
      vehicle = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("vehicle.create-error:\n", error);
      throw error;
    });
};

internals.updateVehicle = (_id,vehicle) => {
 
  return http
    .put(`/vehicle/update`, {
      _id: vehicle._id,
      cityId: vehicle.cityId,
      vNumber: vehicle.vNumber,
      vMakeYear: vehicle.vMakeYear,
      vModelName: vehicle.vModelName,
      // vType: vehicle.vType,
      assignGpsId: vehicle.assignGpsId,
      status:vehicle.status
    })
    .then((result) => {
      vehicle = result.data;
      return vehicle;
    })
    .catch((error) => {
      console.error("vehicle.updateVehicle-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/vehicles.service.js